var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSubscription = function SvgIcoSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M.834 0a.833.833 0 0 0-.825.955L.164 2h15.398l.154-1.045A.833.833 0 0 0 14.892 0zM.01 4.957A.833.833 0 0 1 .834 4h14.332c.51 0 .9.453.824.957L15.833 6H.167zM.834 8c-.52 0-.913.47-.82.982l1.45 7.991A1.25 1.25 0 0 0 2.694 18h10.612a1.25 1.25 0 0 0 1.23-1.027l1.45-7.99a.833.833 0 0 0-.82-.983zm9.518 5.714a.833.833 0 0 0 .001-1.418l-3.082-1.907A.833.833 0 0 0 6 11.098v3.807a.833.833 0 0 0 1.27.71z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoSubscription;